import Body from '../Body';
import Header from '../Header';
import React from 'react';

import Wrapper from '../Wrapper';

import DataProvider from '../DataProvider';
import UserProvider from '../UserProvider';

import styled from 'styled-components';

function App() {
  return (
    <UserProvider>
      <DataProvider>
        <Wrapper>
          <Header />
          <Body />
        </Wrapper>
      </DataProvider>
    </UserProvider>
  );
}

export default App;
